export const labelTypes = {
  TEXT: 'text',
  UPLOAD: 'upload',
}
